<template>
  <div class="topic-regular mb-1 position-relative cursor-pointer border-0 ff-primary">
    <div class="mb-2">
      <s-tag
        v-if="data.session && isShownSessionTag"
        variant="royal-navy"
        type="category"
        cluster="k"
      >
        Sesi {{ data.session }}
      </s-tag>
      <s-tag
        v-if="data.is_addon && hasEnrolled"
        variant="eucalyptus"
        type="category"
        cluster="k"
      >
        Topik Tambahan
      </s-tag>
      <s-tag
        v-if="isWebinarProgram && data.session && shouldShowVerificationStatusLabel"
        class="s-ml-3"
        :variant="getVerificationStatusVariant"
        type="status"
        cluster="k"
      >
        {{ verificationStatusLabel }}
      </s-tag>
    </div>
    <div class="text-left pr-5">
      <span
        class="d-block topic-title fs-16 fw-600"
        :class="{ 'primary-font-color': hasEnrolled, 'text-eucalyptus-700': data.is_addon && !hasEnrolled }"
      >
        {{data.title}}
      </span>
      <span class="fs-12 fw-400 meta-info text-gargoyle">{{data.total_resource}} Aktivitas</span>
      <span v-if="data.duration"> - <span class="fs-12 fw-400 meta-info text-gargoyle">{{formattedDuration}}</span></span>
    </div>
    <img
      src="@/assets/icons/activity-v2/chevron-down.svg"
      class="img-fluid toggle-indicator"
      v-if="hasActivities"
    />
  </div>
</template>
<script>
import moment from 'moment'
import programTrainingTypes from '@/constants/programTrainingTypes.js'
import activityV2GeneralMixin from '@/mixins/activityV2/general'

export default {
  name: 'TopicRegular',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    hasEnrolled: {
      type: Boolean,
      default: false
    }
  },
  mixins: [activityV2GeneralMixin],
  computed: {
    formattedDuration () {
      return moment(moment().startOf('day').minutes(this.data.duration)).format('HH:mm:ss')
    },
    verificationStatusLabel () {
      return this.data.session_sequence?.verification_status_label
    },
    getVerificationStatusVariant () {
      const statusMap = {
        'Gagal Verifikasi': 'danger',
        'Berhasil Verifikasi': 'success',
        'Verifikasi Sedang Diproses': 'neutral'
      }
      return statusMap[this.data.session_sequence?.verification_status_label] || ''
    },
    shouldShowVerificationStatusLabel () {
      return !!this.data.session_sequence?.verification_status_label &&
        this.data.session_sequence?.verification_status_label !== 'Belum Verifikasi' &&
        !!this.isPrakerjaPurchaseType
    },
    hasActivities () {
      return this.data.total_resource > 0
    },
    isSelfPacedLearning () {
      return this.$store.state.activityV2.activityDashboard.training_type === programTrainingTypes.SELF_PACED_LEARNING
    },
    isWebinarProgram () {
      return this.$store.state.activityV2.activityDashboard.training_type === programTrainingTypes.WEBINAR
    },
    isShownSessionTag () {
      return this.isSelfPacedLearning || this.isWebinarProgram
    }
  }
}
</script>
<style scoped>
.topic-regular {
  background-color: transparent;
  user-select: none;
}

.topic-regular:focus,
.topic-regular:active {
  outline: none;
}

.toggle-indicator {
  filter: invert(66%) sepia(0%) saturate(1752%) hue-rotate(140deg) brightness(92%) contrast(84%);
  position: absolute;
  top: 50%;
  right: 0;
  -webkit-transform: translateY(-50%) rotate(0deg);
  -ms-transform: translateY(-50%) rotate(0deg);
  transform: translateY(-50%) rotate(0deg);
  -webkit-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

.not-collapsed .toggle-indicator {
  -webkit-transform: translateY(-50%) rotate(180deg);
  -ms-transform: translateY(-50%) rotate(180deg);
  transform: translateY(-50%) rotate(180deg);
}
</style>
